import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-bild-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeBildHinzufuegenEffects {

    AufgabeBildHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_BILD_HINZUFUEGEN),
        mergeMap((x: ac.PostAufgabeBildHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeBildHinzufuegen(x.aufgabeBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeBildHinzufuegenErfolgreichAction(result, x.aufgabeBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeBildHinzufuegenFehlerAction(error, x.aufgabeBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
